import { ArrowRight, Store } from "lucide-react";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

export function MallPortalPage() {
  return <div className="mall-portal"><div className="mall-portal-copy"><span className="mall-portal-icon"><Store aria-hidden="true" /></span><span className="eyebrow">商城返回入口</span><h1>号商动态广场</h1><p>【🔥号商动态广场】查看海量游戏账号实拍展示，点此前往&gt;&gt;</p><Button component={Link} variant="contained" to="/square" endIcon={<ArrowRight aria-hidden="true" />}>前往动态广场</Button></div></div>;
}
